import React from "react";
import {
  BRANCH_ADDRESS,
  LSP_GRO_NAME,
  LSP_GRO_EMAIL,
  LSP_GRO_PHONE,
} from "../constants";

const PrivacyPolicy = () => (
  <div
    style={{ minHeight: "100vh", background: "#050A18", padding: "0 0 48px 0" }}
  >
    <div
      style={{
        background: "#111827",
        color: "#fff",
        padding: "56px 0 36px 0",
        textAlign: "center",
      }}
    >
      <div className="text-3xl font-bold tracking-wide text-center mb-2">
        <h2>
          <span className="text-[#4FA0FF]">Privacy</span>
          <span className="text-[white] ml-1">Policy</span>
        </h2>
      </div>

      <p style={{ fontSize: "1.1rem", marginTop: 12, color: "#e0e0e0" }}>
        Your privacy is important to us. Please read how we collect, use, and
        protect your data.
      </p>
    </div>

    <div
      style={{
        maxWidth: 900,
        margin: "40px auto",
        background: "#111827",
        borderRadius: 16,
        boxShadow: "0 4px 24px 0 rgba(79, 160, 255, 0.1)",
        padding: "40px 28px",
        color: "#1D3557",
        fontSize: "1.08rem",
        lineHeight: 1.7,
        border: "1px solid gray",
      }}
    >
      <section style={{ marginBottom: 32 }}>
        <h2
          style={{
            fontSize: "1.3rem",
            fontWeight: 700,
            marginBottom: 12,
            color: "#4FA0FF",
          }}
        >
          1. Introduction
        </h2>
        <p className="text-gray-300">
          At Kubermax, we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our services.
        </p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2
          style={{
            fontSize: "1.3rem",
            fontWeight: 700,
            marginBottom: 12,
            color: "#4FA0FF",
          }}
        >
          2. Information We Collect
        </h2>
        <ul style={{ paddingLeft: 20, listStyleType: "disc" }}>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Personal Information:</strong> When you apply for a loan or use our services, we collect details such as your name, address, email, phone number, date of birth, gender, and employment type.
          </li>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Financial Information:</strong> Includes bank account details, credit history, PAN card, Aadhaar number, and other documents required for financial assessment.
          </li>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Usage Information:</strong> Includes technical data like IP address, browser type, device info, and browsing behavior.
          </li>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Identification Documents:</strong> We may require scanned copies of government-issued IDs for identity verification.
          </li>
        </ul>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2
          style={{
            fontSize: "1.3rem",
            fontWeight: 700,
            marginBottom: 12,
            color: "#4FA0FF",
          }}
        >
          3. How We Use Your Information
        </h2>
        <ul style={{ paddingLeft: 20, listStyleType: "disc" }}>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Evaluate loan applications</strong> and determine eligibility
          </li>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Verify identity</strong> and prevent fraud
          </li>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Maintain your account</strong> and provide customer support
          </li>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Comply with legal obligations</strong> including the Prevention of Money Laundering Act, 2002
          </li>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Improve our services</strong> and enhance user experience
          </li>
        </ul>
        <p className="text-gray-300 mt-2">
          We do not share your data with third-party marketers without your explicit consent.
        </p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2
          style={{
            fontSize: "1.3rem",
            fontWeight: 700,
            marginBottom: 12,
            color: "#4FA0FF",
          }}
        >
          4. Data Security
        </h2>
        <p className="text-gray-300">
          We implement technical and organizational safeguards including:
        </p>
        <ul style={{ paddingLeft: 20, listStyleType: "disc", marginTop: 8 }}>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Encryption</strong> of sensitive data
          </li>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Secure servers</strong> with firewall protection
          </li>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Access controls</strong> to limit data access to authorized personnel
          </li>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Regular security audits</strong> and monitoring
          </li>
        </ul>
        <p className="text-gray-300 mt-2">
          However, no system is completely secure, and we cannot guarantee absolute security of your data.
        </p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2
          style={{
            fontSize: "1.3rem",
            fontWeight: 700,
            marginBottom: 12,
            color: "#4FA0FF",
          }}
        >
          5. Your Rights
        </h2>
        <p className="text-gray-300">
          Subject to applicable laws, you have the following rights:
        </p>
        <ul style={{ paddingLeft: 20, listStyleType: "disc", marginTop: 8 }}>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Right to Access:</strong> Request a copy of your personal data
          </li>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Right to Correction:</strong> Correct inaccurate or incomplete information
          </li>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Right to Deletion:</strong> Request deletion of your personal data
          </li>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Right to Restrict Processing:</strong> Limit how we use your data
          </li>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Right to Withdraw Consent:</strong> Withdraw consent for data use when no longer required, especially after loan closure
          </li>
        </ul>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2
          style={{
            fontSize: "1.3rem",
            fontWeight: 700,
            marginBottom: 12,
            color: "#4FA0FF",
          }}
        >
          6. Data Retention and Deletion
        </h2>
        <p className="text-gray-300">
          We retain personal data as necessary for internal records and compliance with regulatory requirements. You can request data deletion if your credit obligations are settled, subject to regulatory permissions. We will retain your information for the period required by applicable laws and regulations.
        </p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2
          style={{
            fontSize: "1.3rem",
            fontWeight: 700,
            marginBottom: 12,
            color: "#4FA0FF",
          }}
        >
          7. Cookies and Tracking
        </h2>
        <p className="text-gray-300">
          We use cookies and similar tracking technologies to:
        </p>
        <ul style={{ paddingLeft: 20, listStyleType: "disc", marginTop: 8 }}>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Enhance your experience</strong> on our platform
          </li>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Track website usage</strong> and analyze performance
          </li>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Remember your preferences</strong> for future visits
          </li>
        </ul>
        <p className="text-gray-300 mt-2">
          You may adjust cookie settings in your browser. However, disabling cookies may affect the functionality of our services.
        </p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2
          style={{
            fontSize: "1.3rem",
            fontWeight: 700,
            marginBottom: 12,
            color: "#4FA0FF",
          }}
        >
          8. Grievance Officer
        </h2>
        <p className="text-gray-300">
          For concerns regarding your data or privacy-related issues, please contact our Grievance Officer:
        </p>
        <ul style={{ paddingLeft: 20, listStyleType: "disc", marginTop: 12 }}>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Name:</strong> {LSP_GRO_NAME}
          </li>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Phone:</strong> {LSP_GRO_PHONE}
          </li>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Email:</strong> {LSP_GRO_EMAIL}
          </li>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Address:</strong> {BRANCH_ADDRESS}
          </li>
        </ul>
      </section>

      <section>
        <h2
          style={{
            fontSize: "1.3rem",
            fontWeight: 700,
            marginBottom: 12,
            color: "#4FA0FF",
          }}
        >
          9. Updates to Privacy Policy
        </h2>
        <p className="text-gray-300">
          This Privacy Policy may be updated from time to time to reflect changes in our practices or regulatory requirements. Any changes will be posted on our website with the revised effective date. We encourage you to review this policy periodically.
        </p>
       
      </section>
    </div>
  </div>
);

export default PrivacyPolicy;